export default __webpack_public_path__ + "static/media/box1_bak4.872fddd2.png";